import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material'

interface IProps {
  loadingText?: string
}

const TranspotsLoading = ({ loadingText }: IProps) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{loadingText ?? 'Loading...'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={50} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default TranspotsLoading
